import { useQuery } from "@tanstack/react-query";
import { backupService } from "@/features/backups/services/backupService";
import { queryKeys } from "@/lib/query-keys";
import type { ListBackupsQuery } from "@/types/backup";

/** Poll while any backup is still being produced so the table reflects completion. */
const REFETCH_WHILE_PENDING = 4000;

export function useBackups(query?: ListBackupsQuery) {
  return useQuery({
    queryKey: queryKeys.backups.list(query),
    queryFn: () => backupService.list(query),
    refetchInterval: (q) => {
      const items = q.state.data?.items ?? [];
      const inFlight = items.some(
        (b) => b.status === "pending" || b.status === "running",
      );
      return inFlight ? REFETCH_WHILE_PENDING : false;
    },
  });
}

export function useBackupSchedule() {
  return useQuery({
    queryKey: queryKeys.backups.schedule(),
    queryFn: () => backupService.getSchedule(),
  });
}
